import React from 'react'
import Nav from './nav'
import Footer from './Footer'
import NativeBanner from './NativeBanner'
import AdBanner from './AdBanner'
export default function Aboutus() {
  // Inline Styles
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f9fa'
    },
    aboutSection: {
      flex: 1,
      maxWidth: '800px',
      margin: '40px auto',
      padding: '40px',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 2px 15px rgba(0,0,0,0.08)',
      lineHeight: '1.8',
      color: '#333'
    },
    heading: {
      textAlign: 'center',
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '30px',
      paddingBottom: '20px',
      borderBottom: '3px solid #007bff',
      display: 'inline-block',
      width: '100%'
    },
    paragraph: {
      fontSize: '16px',
      marginBottom: '20px',
      color: '#555'
    },
    list: {
      listStyle: 'none',
      padding: '0',
      margin: '20px 0'
    },
    listItem: {
      padding: '12px 15px',
      marginBottom: '10px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      borderLeft: '4px solid #007bff',
      fontSize: '15px',
      color: '#444',
      transition: 'all 0.3s ease'
    },
    listItemHover: {
      backgroundColor: '#e9ecef',
      transform: 'translateX(5px)'
    },
    highlight: {
      color: '#007bff',
      fontWeight: '600'
    },
    missionText: {
      backgroundColor: '#f0f7ff',
      padding: '20px',
      borderRadius: '8px',
      margin: '20px 0',
      borderLeft: '4px solid #007bff'
    },
    // Mobile Responsive
    '@media (max-width: 768px)': {
      aboutSection: {
        margin: '20px 15px',
        padding: '25px 20px'
      },
      heading: {
        fontSize: '24px'
      },
      paragraph: {
        fontSize: '14px'
      },
      listItem: {
        fontSize: '14px',
        padding: '10px 12px'
      }
    },
    '@media (max-width: 480px)': {
      aboutSection: {
        margin: '15px 10px',
        padding: '20px 15px'
      },
      heading: {
        fontSize: '20px'
      }
    }
  }

  return (
    <div style={styles.container}>
      <Nav />
              <AdBanner />
      <div style={styles.aboutSection}>
        <h2 style={styles.heading}>About Us</h2>
        
        <div style={styles.missionText}>
          <p style={{...styles.paragraph, margin: 0}}>
            Welcome to <strong style={styles.highlight}>APKNU.com</strong>!
          </p>
        </div>
        
        <p style={styles.paragraph}>
          Our mission is to provide users with easy access to our mobile application and all the information they need before downloading it. We believe in creating simple, reliable, and user-friendly digital solutions that improve everyday life.
        </p>
        
                <NativeBanner />
        <p style={styles.paragraph}>

          On this website, you can:
        </p>
        
        <ul style={styles.list}>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            ✅ Learn about our mobile application and its features.
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            📥 Download the latest version of the app.
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            🔄 Stay updated with new features and announcements.
          </li>
          <li 
            style={styles.listItem}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#e9ecef'
              e.target.style.transform = 'translateX(5px)'
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f8f9fa'
              e.target.style.transform = 'translateX(0)'
            }}
          >
            📧 Contact our support team if you need assistance.
          </li>
        </ul>
        
        <p style={styles.paragraph}>
          We are committed to continuously improving our application based on user feedback and technological advancements.
        </p>
        
        <p style={{...styles.paragraph, marginTop: '30px', textAlign: 'center'}}>
          <strong style={styles.highlight}>Thank you</strong> for choosing our app. We appreciate your trust and support. 🙏
        </p>
      </div>
              <AdBanner />
      <Footer />
    </div>
  )
}